<template>
  <div>
    <el-dialog
      :title="selfDetail.formData.id ? '编辑采购订单' : '新增采购订单'"
      width="1300px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <div>
          <e-form
            ref="refForm"
            :config="formConfig"
            :column="formColumn"
            :data.sync="selfDetail.formData"
          />
          <div class="flex flex-y-center m-t-10">
            <div class="group-title">物料清单</div>
            <el-link class="m-b-5 m-l-10" type="primary" size="mini" @click="chooseShenGou">
              <span>选择采购申请</span>
              <span class="c-red">({{ selfDetail.list.length }})</span>
            </el-link>
            <el-link class="m-b-5 m-l-10" type="success" size="mini" @click="itemAdd"> 增行 </el-link>
          </div>
          <vxe-grid
            ref="refTable"
            :min-height="tableConfig.minHeight"
            :toolbar-config="tableConfig.toolbarConfig"
            :edit-config="tableConfig.editConfig"
            :row-config="tableConfig.rowConfig"
            :mouse-config="tableConfig.mouseConfig"
            :keyboard-config="tableConfig.keyboardConfig"
            :columns="tableColumn"
            :data="selfDetail.list"
            :show-footer="!!selfDetail.list.length"
            :max-height="this.$util.getViewHeight() - 520"
            :footer-method="tableFooterMethod"
          >
            <!-- slot_default -->
            <template #default_list_chan_pin_tu="{ row }">
              <e-upload-image :list.sync="row.list_chan_pin_tu" :limit="5" isDelete />
            </template>
            <template #default_order_amount="{ row }">
              <span class="c-orange">{{ row.order_amount }}</span>
            </template>
            <template #default_operate="{ rowIndex }">
              <el-link title="清空" @click="itemClear(rowIndex)"> 清空 </el-link>
              <el-link title="删行" @click="itemDelete(rowIndex)"> 删行 </el-link>
            </template>

            <!-- slot_edit -->
            <template #edit_bill_code="{ row }">
              <el-input v-model="row.bill_code" size="mini" clearable />
            </template>
            <template #edit_name="{ row }">
              <el-input v-model="row.name" size="mini" clearable />
            </template>
            <template #edit_spec="{ row }">
              <el-input v-model="row.spec" size="mini" clearable />
            </template>
            <template #edit_unit="{ row }">
              <el-input v-model="row.unit" size="mini" clearable />
            </template>
            <template #edit_counts="{ row }">
              <el-input v-model="row.counts" type="number" size="mini" clearable />
            </template>
            <template #edit_order_counts="{ row }">
              <el-input
                v-model="row.order_counts"
                type="number"
                size="mini"
                clearable
                @blur="countsBlur(row)"
              />
            </template>
            <template #edit_goods_price="{ row }">
              <el-input
                v-model="row.goods_price"
                type="number"
                size="mini"
                clearable
                @blur="countsBlur(row)"
              />
            </template>
            <template #edit_remark="{ row }">
              <el-input v-model="row.remark" size="mini" clearable />
            </template>
          </vxe-grid>
          <div>
            <div class="group-title m-t-20">其他要求</div>
            <div
              v-for="(item, index) in selfDetail.formData.qi_ta_yao_qiu_list"
              :key="index"
              class="yao-qiu-item"
            >
              <div>要求{{ index + 1 }}:</div>
              <div class="flex-1">
                <el-input
                  v-model="item.qi_ta_yao_qiu"
                  size="mini"
                  placeholder="请输入..."
                  clearable
                />
              </div>
              <div>
                <el-link
                  class="m-l-5 f-s-16 iconfont icon-add"
                  title="增行"
                  @click="yaoqiuItemAdd(index)"
                />
                <el-link
                  :disabled="selfDetail.formData.qi_ta_yao_qiu_list.length < 3"
                  class="f-s-16 iconfont icon-delete"
                  title="删行"
                  @click="yaoqiuItemDelete(index)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" :loading="saving" :disabled="saving" @click="popupPush">保存</el-button>
      </div>
    </el-dialog>
    <PopupChooseShenGou
      v-if="isShowPopupChooseShenGou"
      :show.sync="isShowPopupChooseShenGou"
      @success="chooseShenGouSuccess"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupChooseShenGou: () => import('./popup-choose-shen-gou')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    code: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      selfShow: false,
      saving: false,
      // 供应商完整数据列表，用于联动查询联系人与电话
      supplierList: [],
      selfDetail: {
        formData: {
          order_code: '', // 采购订单号
          shen_qing_ren_name: '', // 申请人
          shen_qing_ren_id: '',
          shen_qing_bu_men_name: '', // 申请部门
          shen_qing_bu_men_id: '',
          gong_cheng_fu_ze_ren_name: '', // 工程负责人
          pmc_fu_ze_ren_name: '', // PMC负责人
          cai_gou_type: '物料采购', // 采购类型
          order_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 下单日期
          jiao_huo_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 交货日期
          qi_ta_yao_qiu_list: [{ qi_ta_yao_qiu: '' }, { qi_ta_yao_qiu: '' }],
          ke_fu_name: '', // 客服
          supplier_name: '', // 供应商
          supplier_fu_ze_ren: '', // 供应商负责人
          supplier_phone: '', // 供应商电话
          remark: ''
        },
        list: []
      },
      formConfig: {
        inline: true,
        width: '386px'
      },
      formColumn: [
        {
          type: 'text',
          title: '采购订单号',
          field: 'order_code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'text',
          title: '申请人',
          field: 'shen_qing_ren_name',
          disabled: true
        },
        {
          type: 'text',
          title: '申请部门',
          field: 'shen_qing_bu_men_name',
          disabled: true
        },
        {
          type: 'text',
          title: '工程负责人',
          field: 'gong_cheng_fu_ze_ren_name',
          disabled: true
        },
        {
          type: 'text',
          title: 'PMC负责人',
          field: 'pmc_fu_ze_ren_name',
          disabled: true
        },
        {
          type: 'select',
          title: '采购类型',
          field: 'cai_gou_type',
          options: [
            { key: '物料采购', val: '物料采购' },
            { key: '办公用品', val: '办公用品' },
            { key: '劳保用品', val: '劳保用品' },
            { key: '设备零配件', val: '设备零配件' },
            { key: '清洁用品', val: '清洁用品' },
            { key: '其他', val: '其他' }
          ]
        },
        {
          type: 'date',
          title: '下单日期',
          field: 'order_date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'date',
          title: '交货日期',
          field: 'jiao_huo_date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'text',
          title: '客服',
          field: 'ke_fu_name'
        },
        {
          type: 'autocomplete',
          title: '供应商',
          field: 'supplier_name',
          // 供应商建议列表：输入时实时过滤，可不匹配自由输入
          querySearch: (queryString, callback) => {
            let list = this.supplierList.map((item) => ({ value: item.supplier_name }))
            let result = queryString
              ? list.filter((item) => item.value.toLowerCase().includes(queryString.toLowerCase()))
              : list
            callback(result)
          }
        },
        {
          type: 'text',
          title: '供应商负责人',
          field: 'supplier_fu_ze_ren'
        },
        {
          type: 'text',
          title: '供应商电话',
          field: 'supplier_phone'
        },
        {
          type: 'text',
          title: '备注',
          field: 'remark'
        }
      ],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '来源申请单号',
          field: 'source_bill_code',
          width: 130
        },
        {
          title: '销售订单',
          field: 'bill_code',
          width: 110,
          slots: { edit: 'edit_bill_code' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '物料图片',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '物料名称',
          field: 'name',
          slots: { edit: 'edit_name' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '物料类型',
          field: 'wu_liao_type',
          width: 80
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 110,
          slots: { edit: 'edit_spec' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单位',
          field: 'unit',
          width: 60,
          slots: { edit: 'edit_unit' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '需求数量',
          field: 'counts',
          width: 80,
          slots: { edit: 'edit_counts' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '下单数量',
          field: 'order_counts',
          width: 90,
          slots: { edit: 'edit_order_counts' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          width: 80,
          slots: { edit: 'edit_goods_price' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '金额(元)',
          field: 'order_amount',
          slots: { default: 'default_order_amount' },
          width: 90
        },
        {
          title: '备注',
          field: 'remark',
          slots: { edit: 'edit_remark' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '操作',
          slots: { default: 'default_operate' },
          width: 100
        }
      ],
      isShowPopupChooseShenGou: false
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return true
          }
        },
        keyboardConfig: {
          isEdit: true
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    accountInfo() {
      return this.$store.state.loginAccount
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    // 监听供应商变化，联动填充负责人与电话
    'selfDetail.formData.supplier_name'(val) {
      if (val && this.supplierList.length) {
        let target = this.supplierList.find((item) => item.supplier_name === val)
        if (target) {
          this.selfDetail.formData.supplier_fu_ze_ren = target.linkman || ''
          this.selfDetail.formData.supplier_phone = target.linkman_phone || ''
        }
      } else if (!val) {
        this.selfDetail.formData.supplier_fu_ze_ren = ''
        this.selfDetail.formData.supplier_phone = ''
      }
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getSupplierList()
    if (this.code) {
      this.getDetailData()
    } else {
      this.selfDetail.formData.shen_qing_ren_name = this.accountInfo.nick_name
      this.selfDetail.formData.shen_qing_ren_id = this.accountInfo.id
      this.selfDetail.formData.shen_qing_bu_men_name = (this.accountInfo.bu_men_name || []).join(',')
      this.selfDetail.formData.shen_qing_bu_men_id = (this.accountInfo.bu_men_id || []).join(',')
    }
  },
  methods: {
    // 选择可转单的采购申请明细
    chooseShenGou() {
      this.isShowPopupChooseShenGou = true
    },
    chooseShenGouSuccess(list) {
      let oldList = this.$util.deepCopy(this.selfDetail.list)
      let newList = this.$util.deepCopy(list)
      let resultEnd = []
      newList.forEach((itemNd) => {
        let isRepeat = oldList.some((itemSt) => itemSt.source_item_id === itemNd.source_item_id)
        if (isRepeat) return
        let orderCounts = Number(itemNd.un_ordered_counts || 0)
        let price = Number(itemNd.goods_price || 0)
        resultEnd.push({
          source_bill_id: itemNd.shen_gou_bill_id,
          source_bill_code: itemNd.shen_gou_code,
          source_item_id: itemNd.source_item_id,
          bill_code: itemNd.bill_code || '',
          list_chan_pin_tu: itemNd.list_chan_pin_tu || [],
          name: itemNd.name || '',
          wu_liao_type: itemNd.wu_liao_type || '',
          spec: itemNd.spec || '',
          unit: itemNd.unit || '',
          counts: itemNd.shen_gou_counts || '',
          order_counts: orderCounts,
          goods_price: itemNd.goods_price || '',
          order_amount: this.$XEUtils.multiply(price, orderCounts),
          remark: ''
        })
      })
      this.selfDetail.list = [...oldList, ...resultEnd]
      // 表头只读继承：首次转单时带出供应商/客服/负责人/采购类型/交期
      let first = newList[0]
      if (first) {
        let fd = this.selfDetail.formData
        if (!fd.supplier_name) {
          fd.supplier_name = first.supplier_name || ''
          fd.supplier_fu_ze_ren = first.supplier_fu_ze_ren || ''
          fd.supplier_phone = first.supplier_phone || ''
        }
        if (!fd.ke_fu_name) fd.ke_fu_name = first.ke_fu_name || ''
        if (!fd.gong_cheng_fu_ze_ren_name) fd.gong_cheng_fu_ze_ren_name = first.gong_cheng_fu_ze_ren_name || ''
        if (!fd.pmc_fu_ze_ren_name) fd.pmc_fu_ze_ren_name = first.pmc_fu_ze_ren_name || ''
        if (first.shen_gou_type) fd.cai_gou_type = first.shen_gou_type
        if (first.qi_wang_date) fd.jiao_huo_date = first.qi_wang_date.slice(0, 10)
      }
    },
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/caiGouDingDan/detail',
        params: { code: this.code }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let formData = res.data.formData
          if (!formData.qi_ta_yao_qiu_list) formData.qi_ta_yao_qiu_list = []
          let len = formData.qi_ta_yao_qiu_list.length
          if (len === 0) {
            formData.qi_ta_yao_qiu_list.push({ qi_ta_yao_qiu: '' }, { qi_ta_yao_qiu: '' })
          }
          if (len === 1) {
            formData.qi_ta_yao_qiu_list.push({ qi_ta_yao_qiu: '' })
          }
          formData.supplier_name = formData.supplier_name || ''
          formData.supplier_fu_ze_ren = formData.supplier_fu_ze_ren || ''
          formData.supplier_phone = formData.supplier_phone || ''
          let list = (res.data.list || []).map((item) => {
            item.list_chan_pin_tu = item.list_chan_pin_tu || []
            return item
          })
          this.selfDetail = { formData, list }
        }
      })
    },
    // 获取供应商列表（建议列表 + 负责人/电话联动）
    getSupplierList() {
      this.$api({
        method: 'post',
        url: '/admin/supplier',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' },
          filterData: {}
        }
      })
        .then((res) => {
          if (res.status === 200 && res.data.state === 'ok') {
            this.supplierList = res.data.page.list || []
          }
        })
        .catch(() => {})
    },
    // 表格底部合计
    tableFooterMethod({ columns, data }) {
      data.forEach((item) => {
        item.order_amount = this.$XEUtils.multiply(
          Number(item.goods_price),
          Number(item.order_counts)
        )
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'order_counts', 'order_amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    },
    // 单价或下单数量失焦时自动计算金额
    countsBlur(row) {
      row.order_amount = this.$XEUtils.multiply(
        Number(row.goods_price),
        Number(row.order_counts)
      )
    },
    // 项-清空
    itemClear(index) {
      let row = this.selfDetail.list[index]
      if (!row) return
      row.bill_code = ''
      row.name = ''
      row.spec = ''
      row.unit = ''
      row.counts = ''
      row.order_counts = ''
      row.goods_price = ''
      row.order_amount = ''
      row.remark = ''
    },
    // 手工增行
    itemAdd() {
      this.selfDetail.list.push({
        source_bill_id: '',
        source_bill_code: '',
        source_item_id: '',
        bill_code: '',
        list_chan_pin_tu: [],
        name: '',
        wu_liao_type: '',
        spec: '',
        unit: '',
        counts: '',
        order_counts: '',
        goods_price: '',
        order_amount: '',
        remark: ''
      })
    },
    // 项-删除
    itemDelete(index) {
      this.selfDetail.list.splice(index, 1)
    },
    // 要求项-新增
    yaoqiuItemAdd(index) {
      this.selfDetail.formData.qi_ta_yao_qiu_list.splice(index + 1, 0, { qi_ta_yao_qiu: '' })
    },
    // 要求项-删除
    yaoqiuItemDelete(index) {
      this.selfDetail.formData.qi_ta_yao_qiu_list.splice(index, 1)
    },
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    popupPush() {
      if (this.saving) return
      if (!this.selfDetail.list.length) {
        this.$message.warning('请先添加物料明细')
        return
      }
      let invalid = this.selfDetail.list.find(
        (item) => !item.name || Number(item.order_counts) <= 0
      )
      if (invalid) {
        this.$message.warning('请填写物料名称，且下单数量必须大于 0')
        return
      }
      let data = this.$util.deepCopy(this.selfDetail)
      data.formData.qi_ta_yao_qiu_list = (data.formData.qi_ta_yao_qiu_list || []).filter(
        (item) => item.qi_ta_yao_qiu
      )
      data.list.forEach((item) => {
        item.order_amount = this.$XEUtils.multiply(
          Number(item.goods_price),
          Number(item.order_counts)
        )
      })
      this.saving = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/caiGouDingDan/saveOrUpdate',
        data
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success(res.data.msg || '保存成功')
            this.popupCancel()
            this.$emit('success')
          } else if (res.data.msg) {
            this.$message.error(res.data.msg)
          }
        })
        .catch(() => {})
        .then(() => {
          this.saving = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .yao-qiu-item {
    display: flex;
    align-items: center;
    margin-top: 5px;
  }
}
</style>
